<div class="coworking-home-bookings-container">
  <div class="header">
    <div class="title">
      <div class="section-title">
        {{ "coworking-home.bookings.title" | translate }}
      </div>
      <span> {{ getTodayDate }}</span>
    </div>
    <div class="filters-section">
      <div class="filter" [formGroup]="filterForm">
        <cowing-input-dropdown [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
                               [control]="filterForm.get('space_id')" [label]="'coworker.booking.space' | translate"
                               [options]="filterSpacesList" [type]="'object'">
        </cowing-input-dropdown>
      </div>
      <div class="filter">
        <cowing-input-dropdown [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
                               [control]="filterForm.get('state_id')" [label]="'coworking-home.bookings.states' | translate"
                               [options]="bookingStates" [type]="'object'">
        </cowing-input-dropdown>
      </div>
    </div>
  </div>
  <div class="table-header">
    <div class="head">
      {{ "coworking-home.bookings.table-headers.coworker" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.code" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.date" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.duration" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.hour" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.capacity" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.space" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.price" | translate }}
    </div>
    <div class="head">
      {{ "coworking-home.bookings.table-headers.state" | translate }}
    </div>
  </div>

  <div class="table-container" *ngIf="bookingsList.length">
    <div class="table" *ngFor="let booking of bookingsList">
      <div class="row">
        <div class="bold ellipsis">{{ booking.coworker.name }}</div>
        <div class="ellipsis">{{ booking.id }}</div>
        <div class="ellipsis">{{ booking.start_date }}</div>
        <div class="semibold ellipsis">{{ booking.duration.name }}</div>
        <div class="ellipsis"> {{ booking.start_time }} a {{ booking.end_time }}</div>
        <div class="ellipsis">
          {{ booking.space.capacity }}
        </div>
        <div class="ellipsis">{{ booking.space.name }}</div>
        <div class="bold ellipsis">{{ booking.price }} â¬</div>
        <div class="status ellipsis" [ngClass]="'c-' + booking.state.id"
             (click)="openBookingModal(booking.id, booking.state.id)">
          {{ booking.state.name }}
        </div>
      </div>
    </div>
    <div class="action-pagination">
      <div class="pagination">
        <img *ngIf="previousPage !== null" [src]="getLeftArrowIcon" alt="" (click)="setPreviousPage()" />
        <img *ngIf="previousPage === null" [src]="getDisabledLeftArrowIcon" alt="" />
        <span> {{ filterForm.get("page").value + 1 }} </span>
        <img *ngIf="nextPage !== null" [src]="getRightArrowIcon" alt="" (click)="setNextPage()" />
        <img *ngIf="nextPage === null" [src]="getDisabledRightArrowIcon" alt="" />
      </div>
    </div>
  </div>
  <div *ngIf="!bookingsList.length" class="table-empty">
    <img [src]="getCalendarIcon" alt="" />
    <span>{{ "coworker.bookings.no-bookings" | translate }}</span>
  </div>
</div>
